import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/DrawnCheck/DrawnCheck.tsx
import * as React from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var drawnCheckVariants = cva("buyscout-drawn-check", {
  variants: {
    shape: {
      "check": "",
      "check-circle": "buyscout-drawn-check--circle"
    }
  },
  defaultVariants: {
    shape: "check"
  }
});
var CHECK = "M4.12 12.71 9 17.59 20.3 6.29";
var CIRCLE_CHECK = "M5.7 11.3 10 15.59 18.3 7.29";
function DrawnCheck({ ref, shape, drawn = false, className, ...props }) {
  const maskId = React.useId();
  const classes = [drawnCheckVariants({ shape }), className].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx(
    "svg",
    {
      ref,
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      fill: "none",
      "aria-hidden": true,
      focusable: "false",
      className: classes,
      "data-drawn": drawn || void 0,
      ...props,
      children: shape === "check-circle" ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs("mask", { id: maskId, children: [
          /* @__PURE__ */ jsx("rect", { width: "24", height: "24", fill: "#fff" }),
          /* @__PURE__ */ jsx("path", { className: "buyscout-drawn-check__stroke", d: CIRCLE_CHECK, pathLength: 1, stroke: "#000", strokeWidth: 2 })
        ] }),
        /* @__PURE__ */ jsx("circle", { cx: "12", cy: "12", r: "10", fill: "currentColor", mask: `url(#${maskId})` })
      ] }) : /* @__PURE__ */ jsx("path", { className: "buyscout-drawn-check__stroke", d: CHECK, pathLength: 1, stroke: "currentColor", strokeWidth: 2 })
    }
  );
}
DrawnCheck.displayName = "DrawnCheck";
export {
  DrawnCheck
};
//# sourceMappingURL=DrawnCheck.mjs.map